enum TaskRecurrenceType {
    Inactive = 0,
    FixedDay = 1,
    FixedWeekDay = 2,
    AfterDays = 3
}

export default TaskRecurrenceType;